// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2VPO4"};